angular.module('zc.commonApi')

.factory "ProjectNewsletterParameter", ($resource, $q, BaseProjectCrudService) ->
  class ProjectNewsletterParameter extends BaseProjectCrudService

  new ProjectNewsletterParameter(
    $resource
    $q
    "/api/projects/:projectId/newsletter_parameters/:id"
    "newsletter_parameter"
    "newsletter_parameters"
  )





// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/newsletter_parameter.service.coffee